import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import React, { useContext } from 'react';
import DesktopProfileTop728x90 from '@wix/da-ads/pkg/adunits/anon/DesktopProfileTop728x90';
import DesktopProfileBottom728x90 from '@wix/da-ads/pkg/adunits/anon/DesktopProfileBottom728x90';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';

import s from './LeaderboardWrapper.scss';

export interface Props {
  children: React.ReactNode;
  adSafety: string;
}

const LeaderboardWrapper: React.FC<Props> = ({ children, adSafety }) => {
  const isMobile = useContext(MobileContext);
  const showAd = useShouldRenderAdArea(adSafety);
  const adsType = useAdsType();

  if (isMobile || !showAd || adsType !== 'anon') {
    return <>{children}</>;
  }

  return (
    <>
      <div className={s['top']}>
        <ErrorBoundary debugComponent="DesktopProfileTopDisplay728x90">
          <DesktopProfileTop728x90 safety={adSafety} />
        </ErrorBoundary>
      </div>
      {children}
      <div className={s['bottom']}>
        <ErrorBoundary debugComponent="DesktopProfileBottomDisplay728x90">
          <DesktopProfileBottom728x90 safety={adSafety} />
        </ErrorBoundary>
      </div>
    </>
  );
};
LeaderboardWrapper.displayName = 'LeaderboardWrapper';

export default LeaderboardWrapper;
